import { a as e } from "./theme-B90C-74v.js";
import { jsx as r } from "react/jsx-runtime";
var o = "_container_t5cf2_1", d = "_dot_t5cf2_15", s = "_loaderDot_t5cf2_1", t = {
  container: o,
  dot: d,
  loaderDot: s
}, l = ({ color: a }) => /* @__PURE__ */ r("div", {
  className: t.container,
  style: a ? { "--loader-color": e.tag.text[a] } : void 0,
  children: /* @__PURE__ */ r("div", { className: t.dot })
});
export {
  l as t
};
